import { render } from "./StarColumnTabs.vue?vue&type=template&id=04d8f614&scoped=true&ts=true"
import script from "./StarColumnTabs.vue?vue&type=script&lang=ts"
export * from "./StarColumnTabs.vue?vue&type=script&lang=ts"

import "./StarColumnTabs.vue?vue&type=style&index=0&id=04d8f614&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d8f614"]])

export default __exports__